import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import Person from 'src/entities/Person';
import { Moment } from 'moment';

export interface ApiPersonResponse {
  id: number;
  name: string;
  profilePicture?: string;
  personType: string;
  idExpirationDate?: Moment;
  surname: string;
  linkedinProfile?: string;
  displayName: string;
  percentCompleted?: number;
}

interface ApiPersonCreateRequest {
}

export class PersonFactory extends BaseFactory<Person> {
  public toEntity(args: ApiPersonResponse): Person {
    return new Person ({
      displayName: args.displayName,
      id: args.id,
      idExpirationDate: args.idExpirationDate,
      linkedinProfile: args.linkedinProfile,
      name: args.name,
      personType: args.personType,
      profilePicture: args.profilePicture,
      surname: args.surname,
      percentCompleted: args.percentCompleted || 0,
    });
  }

  public toRequest(person: Person): ApiPersonCreateRequest {
    return person;
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/PersonFactory.tsx